module.exports = __webpack_public_path__ + "static/media/ic_stocks.8769144b.svg";